import { render, staticRenderFns } from "./RelatorioPesquisaSatisfacaoHome.vue?vue&type=template&id=3ebc554a&scoped=true&"
import script from "./RelatorioPesquisaSatisfacaoHome.vue?vue&type=script&lang=js&"
export * from "./RelatorioPesquisaSatisfacaoHome.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioPesquisaSatisfacaoHome.vue?vue&type=style&index=0&id=3ebc554a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebc554a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs,VTabsItems})
